import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Modal, Form } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import axios from "axios";
import "../css/Admin_css/admin-customize.css";
import myToast from "../Utils/MyToast";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";

const MODAL_RADIUS = 16;
const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

const EXAM_TYPES = [
  { value: "EXAM", label: "EXAM" },
  { value: "CLASS_TEST", label: "CLASS_TEST" },
];

function normalizeExamType(value) {
  const v = String(value || "")
    .trim()
    .toUpperCase()
    .replace(/\s+/g, "_");
  return v === "CLASS_TEST" ? "CLASS_TEST" : "EXAM";
}

const DIALOG_STYLES = `
  .modal.show { display: block !important; opacity: 1 !important; }
  .modal.fade.show { opacity: 1 !important; }
  .mdl-edit-exam-dialog.modal-dialog {
    z-index: 1050 !important;
    position: relative;
    margin: 0.45rem auto 1rem;
    max-width: 560px;
  }
  .mdl-edit-exam-dialog.modal-dialog.modal-dialog-centered {
    min-height: calc(100% - 1rem);
  }
  .modal-backdrop { z-index: 1040 !important; }
  .modal-backdrop.show { opacity: 0.5 !important; }
  .mdl-edit-exam-dialog .modal-content {
    z-index: 1051 !important;
    position: relative;
    border-radius: ${MODAL_RADIUS}px;
    overflow: hidden;
    border: 1.5px solid #b3e5fc;
    box-shadow: 0 12px 28px rgba(2, 136, 209, 0.14);
    background: #fff;
  }
  .mdl-edit-exam-dialog .modal-header {
    border: none;
    padding: 12px 16px;
    background: linear-gradient(135deg, #03a9f4 0%, #0288d1 55%, #01579b 100%);
  }
  .mdl-edit-exam-dialog .modal-header .close {
    color: #fff;
    opacity: 0.92;
    text-shadow: none;
    font-size: 1.35rem;
    font-weight: 400;
    padding: 0.35rem 0.55rem;
  }
  .mdl-edit-exam-dialog .modal-body {
    padding: 12px 14px 10px;
    background: linear-gradient(180deg, #f7fcff 0%, #ffffff 42%);
  }
  .mdl-edit-exam-dialog .modal-footer {
    border-top: 1px solid #e1f5fe;
    padding: 8px 14px;
    background: #f0f9ff;
  }
  .mee-title {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin: 0;
    color: #fff;
    width: 100%;
    padding-right: 18px;
  }
  .mee-title__icon {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(255,255,255,0.18);
    border: 1px solid rgba(255,255,255,0.35);
    font-size: 15px;
  }
  .mee-title__text { min-width: 0; }
  .mee-title__main {
    font-size: 16px;
    font-weight: 800;
    line-height: 1.2;
  }
  .mee-title__sub {
    margin-top: 2px;
    font-size: 11px;
    font-weight: 500;
    color: rgba(255,255,255,0.88);
    line-height: 1.3;
  }
  .mee-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 10px;
  }
  .mee-pill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    min-height: 26px;
    padding: 3px 9px;
    border-radius: 999px;
    border: 1px solid #b3e5fc;
    background: #e1f5fe;
    color: #01579b;
    font-size: 11px;
    font-weight: 700;
  }
  .mee-pill strong {
    font-weight: 800;
  }
  .mee-form {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
    border-radius: 10px;
    border: 1.5px solid #b3e5fc;
    background: #fff;
  }
  .mee-form .form-group { margin-bottom: 0; }
  .mee-form label {
    display: block;
    margin-bottom: 4px;
    font-size: 10px;
    font-weight: 800;
    color: #0277bd;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }
  .mee-form .form-control {
    min-height: 34px;
    border-radius: 8px;
    border: 1.5px solid #b3e5fc;
    font-size: 12px;
    font-weight: 600;
    color: #0f172a;
    background: #f8fcff;
  }
  .mee-form .form-control:focus {
    border-color: #03a9f4;
    box-shadow: 0 0 0 2px rgba(3, 169, 244, 0.16);
    background: #fff;
  }
  .mee-type-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }
  .mee-type-chip {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    min-height: 30px;
    padding: 4px 10px 4px 5px;
    border-radius: 999px;
    border: 1.5px solid #81d4fa;
    background: #fff;
    color: #01579b;
    font-size: 11px;
    font-weight: 800;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  }
  .mee-type-chip:hover:not(:disabled) {
    border-color: #0288d1;
    background: #e1f5fe;
  }
  .mee-type-chip:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
  .mee-type-chip.is-active {
    background: #33b536;
    border-color: #2a9a2d;
    color: #fff;
  }
  .mee-type-chip__num {
    width: 18px;
    height: 18px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: 800;
    background: #e1f5fe;
    color: #0288d1;
  }
  .mee-type-chip.is-active .mee-type-chip__num {
    background: #fff;
    color: #2a9a2d;
  }
  .mee-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-height: 34px;
    padding: 6px 14px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 800;
    cursor: pointer;
    border: 1.5px solid transparent;
    transition: background 0.15s ease, border-color 0.15s ease, transform 0.12s ease;
  }
  .mee-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
    transform: none !important;
  }
  .mee-btn--ghost {
    background: #fff;
    border-color: #cbd5e1;
    color: #475569;
    margin-right: 6px;
  }
  .mee-btn--ghost:hover:not(:disabled) {
    background: #f1f5f9;
    border-color: #94a3b8;
  }
  .mee-btn--primary {
    background: linear-gradient(135deg, #03a9f4 0%, #0288d1 100%);
    border-color: #0288d1;
    color: #fff;
    box-shadow: 0 3px 8px rgba(2, 136, 209, 0.24);
  }
  .mee-btn--primary:hover:not(:disabled) {
    transform: translateY(-1px);
  }
  .mee-loading {
    min-height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const MdlEditExam = ({ onClose, examName, onSave }) => {
  const loggedIn = useMemo(
    () => localStorage.getItem("token") !== null,
    []
  );

  const [loading, setLoading] = useState(false);
  const [examId, setExamId] = useState("");
  const [examNameOld, setExamNameOld] = useState("");
  const [examNameNew, setExamNameNew] = useState("");
  const [examRemarkOld, setExamRemarkOld] = useState("");
  const [examRemarkNew, setExamRemarkNew] = useState("");
  const [examType, setExamType] = useState("EXAM");
  const [sessionId, setSessionId] = useState("");
  const [statusName, setStatusName] = useState("");

  useEffect(() => {
    if (!examName) return;
    setExamId(examName.exam_id || "");
    setExamNameOld(examName.exam_name || "");
    setExamNameNew(examName.exam_name || "");
    setExamRemarkOld(examName.exam_remark || "");
    setExamRemarkNew(examName.exam_remark || "");
    setExamType(normalizeExamType(examName.exam_type));
    setSessionId(examName.session_id || "");
    setStatusName(examName.status_name || "");
  }, [examName]);

  const handleClose = useCallback(() => {
    if (onClose) onClose();
  }, [onClose]);

  const handleSubmit = useCallback(async () => {
    const name = String(examNameNew || "").trim();
    if (!name) {
      myToast.notify_warning("Exam name cannot be empty");
      return;
    }
    if (!examId || !sessionId) {
      myToast.notify_warning("Exam details are incomplete");
      return;
    }

    const schoolCode = SessionManager.getSchoolCode();
    const staff = SessionManager.getStaffDetails();
    const staffId = staff?.staff_id;
    if (!schoolCode || !staffId) {
      myToast.notify_warning("Staff or school details missing");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE()}updateExamName.php`, {
        params: {
          school_code: schoolCode,
          staff_id: staffId,
          exam_id: examId,
          exam_name_old: examNameOld,
          exam_name_new: name,
          exam_remark_old: examRemarkOld,
          exam_remark_new: String(examRemarkNew || "").trim(),
          exam_type: examType || "EXAM",
          session_id: sessionId,
        },
      });

      if (response.data?.api_status === "OK") {
        myToast.notify_success("Updated successfully!");
        if (onSave) onSave(sessionId);
      } else {
        myToast.notify_warning(
          response.data?.api_remark || "Update failed. Please try again."
        );
      }
    } catch (error) {
      console.error("Edit exam error:", error);
      myToast.notify_error("An error occurred while updating the exam.");
    } finally {
      setLoading(false);
    }
  }, [
    examId,
    examNameOld,
    examNameNew,
    examRemarkOld,
    examRemarkNew,
    examType,
    sessionId,
    onSave,
  ]);

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  return (
    <div>
      <style>{DIALOG_STYLES}</style>
      <Modal
        show
        onHide={handleClose}
        animation={false}
        size="md"
        dialogClassName="mdl-edit-exam-dialog"
        aria-labelledby="mdl-edit-exam-title"
        centered
        backdrop="static"
        enforceFocus={false}
        restoreFocus={false}
      >
        <Modal.Header closeButton>
          <div className="mee-title" id="mdl-edit-exam-title">
            <span className="mee-title__icon" aria-hidden>
              <i className="fa fa-edit" />
            </span>
            <div className="mee-title__text">
              <div className="mee-title__main">Edit Exam</div>
              <div className="mee-title__sub">
                Update exam name, type, and remark
              </div>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          {loading ? (
            <div className="mee-loading">
              <MyLoader />
            </div>
          ) : (
            <>
              <div className="mee-meta">
                {examId ? (
                  <span className="mee-pill">
                    ID: <strong>{examId}</strong>
                  </span>
                ) : null}
                {statusName ? (
                  <span className="mee-pill">
                    Status: <strong>{statusName}</strong>
                  </span>
                ) : null}
              </div>

              <Form className="mee-form">
                <Form.Group>
                  <Form.Label>Exam Type</Form.Label>
                  <div
                    className="mee-type-chips"
                    role="group"
                    aria-label="Exam type"
                  >
                    {EXAM_TYPES.map((type, idx) => (
                      <button
                        key={type.value}
                        type="button"
                        className={`mee-type-chip${
                          examType === type.value ? " is-active" : ""
                        }`}
                        onClick={() => setExamType(type.value)}
                        disabled={loading}
                      >
                        <span className="mee-type-chip__num">{idx + 1}</span>
                        {type.label}
                      </button>
                    ))}
                  </div>
                </Form.Group>

                <Form.Group>
                  <Form.Label>Exam Name</Form.Label>
                  <Form.Control
                    type="text"
                    value={examNameNew}
                    onChange={(e) => setExamNameNew(e.target.value)}
                    placeholder="Enter exam name"
                    disabled={loading}
                    autoFocus
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>Exam Remark (optional)</Form.Label>
                  <Form.Control
                    type="text"
                    value={examRemarkNew}
                    onChange={(e) => setExamRemarkNew(e.target.value)}
                    placeholder="Enter exam remark"
                    disabled={loading}
                  />
                </Form.Group>
              </Form>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <button
            type="button"
            className="mee-btn mee-btn--ghost"
            onClick={handleClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="button"
            className="mee-btn mee-btn--primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            <i className="fa fa-save" aria-hidden />
            {loading ? "Saving…" : "Save Changes"}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default MdlEditExam;
